module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/partnerUI/partner-manage-product/partner-manage-product.component.scss
// module id = ./src/app/partnerUI/partner-manage-product/partner-manage-product.component.scss
// module chunks = main